import { Field, FieldError, FieldLabel } from '@talentmesh/ui/components/field';
import { useState } from 'react';
import { ImageCrop } from '@/Components/ImageCrop/ImageCrop';
import { defaultAllowedImageTypes, ImageCropStrings } from '@/Components/ImageCrop/ImageCropUtils';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';

export interface ClientImageCropProps {
    src: string;
    handleUploadImage: (image: Blob) => Promise<void>;
    handleResetImage: () => Promise<void>;
}

const ClientImageCrop = ({ src, handleUploadImage, handleResetImage }: ClientImageCropProps) => {
    const { showFailToaster } = useNotificationContext();
    const [validationMessage, setValidationMessage] = useState<string>('');

    const imageCropStrings: ImageCropStrings = {
        selectButtonTooltipText: UIStrings.UploadImage,
        removeButtonTooltipText: UIStrings.RemoveImage,
        uploadButtonText: UIStrings.Upload,
        dialogHeaderText: UIStrings.CropYourImage,
        dialogContentText: UIStrings.SelectTheAreaToBeCropped,
    };

    const validateCallback = (value: Blob): boolean => {
        if (value.size > 1024 * 1024 * 1) {
            setValidationMessage(UIStrings.DefaultImageSizeValidationErrorText);
            return false;
        }

        if (defaultAllowedImageTypes.find((imageType) => imageType === value.type) === undefined) {
            setValidationMessage(UIStrings.DefaultImageTypeValidationErrorText);
            return false;
        }

        if (validationMessage) {
            setValidationMessage('');
        }

        return true;
    };

    const processingErrorCallback = () => {
        showFailToaster(UIStrings.DefaultImageCropDialogProcessingErrorText);
    };

    return (
        <Field data-cy="ClientImageCrop">
            <FieldLabel>{UIStrings.UploadLogo}</FieldLabel>
            <FieldError>{validationMessage}</FieldError>
            <div className="flex">
                <ImageCrop
                    src={src}
                    circularCrop
                    strings={imageCropStrings}
                    validateCallback={validateCallback}
                    uploadCallbackAsync={handleUploadImage}
                    resetCallbackAsync={handleResetImage}
                    processingErrorCallback={processingErrorCallback}
                />
            </div>
        </Field>
    );
};

export default ClientImageCrop;
